import * as React from 'react';
import P from '@hero/ui-kit/typography/P';
import { IStickyNote } from '../../types';

interface StickyNoteProps {
    note: IStickyNote;
}

const StickyNote: React.FC<StickyNoteProps> = ({ note }) => {
    return (
        <div
            style={{
                backgroundColor: '#fff3a0',
                border: '1px solid #e6d885',
                borderRadius: '8px',
                padding: '12px 16px',
                boxShadow: '2px 3px 8px rgba(0, 0, 0, 0.15)',
                position: 'fixed',
                top: '60px',
                right: '20px',
                maxWidth: '400px',
                transform: 'rotate(-1deg)',
                fontFamily: 'Arial, sans-serif',
                zIndex: 1000
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '-8px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    width: '20px',
                    height: '15px',
                    backgroundColor: '#ddd',
                    borderRadius: '2px',
                    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.3)'
                }}
            />
            <P
                noDefaultMargin
                style={{
                    fontSize: '13px',
                    lineHeight: '1.4',
                    color: '#333',
                    marginBottom: '8px'
                }}
            >
                {note.log_message}
            </P>
            <P
                noDefaultMargin
                styles={{
                    fontSize: '10px',
                    color: '#666',
                    fontStyle: 'italic'
                }}
            >
                {note.agent} at {note.created_at}
            </P>
        </div>
    );
};

export default StickyNote;
